var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"size":70,"width":7,"indeterminate":"","color":"indigo"}},[_c('v-img',{attrs:{"lazy-src":_vm.logoLoading,"max-height":"40","max-width":"40","src":_vm.logoLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }